import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import ContentContainer from "../../components/container/ContainerComponent";
import MaterialTable from "material-table";
import { findSHU } from "../../actions/koperasi/koperasi_action";
import { getSHUKoperasiPending, getSHUKoperasi, getSHUKoperasiError } from "../../reducers/koperasi/koperasi_reducer";
import MenuItem from "@material-ui/core/MenuItem";
import DetailButtonComponent from "../../components/global-components/DetailButtonComponent";
import PaginationComponent from "../../components/table/PaginationComponent";
import { Paper } from "@material-ui/core";
import HeaderSHU from "./HeaderSHU";
import TableStatusComponent from "../../components/global-components/TableStatusComponent";
import { getUser } from "../../helpers/user";
import moment from "moment";
import localization from "moment/locale/id";

class SHU extends Component {
    constructor(props) {
        super(props);
        this.tableRef = React.createRef();
        this.state = {
            search: "",
            status: "",
            year: "",
            columns: [
                {
                    title: "No", field: "name",
                    render: (rowData) => {
                        return <>{rowData.no}</>
                    },
                    width: 20,
                    headerStyle: {
                        paddingLeft: 40,
                    },
                    cellStyle: {
                        paddingLeft: 40,
                    },
                },
                {
                    title: "Tanggal Tagihan",
                    render: (data) => {
                        return moment(data.created_at).locale("id", localization).format("DD MMMM YYYY");
                    }
                },
                { title: "Nama Dokter", field: "member_data.name" },
                { title: "ID Member", field: "member_data.member_profile.paboi_id" },
                {
                    title: "Total Pembayaran",
                    render: (data) => {
                        const total = data.total_required_deposit.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
                        return "Rp " + total;
                    }
                },
                {
                    title: "Status",
                    render: (data) => {
                        return (
                            <TableStatusComponent
                                status={
                                    data.status === 0
                                        ? "Unpaid"
                                        : data.status === 1
                                            ? "Paid"
                                            : data.status === 2
                                                ? "Overdue"
                                                : "Late Payment"
                                }
                            />
                        );
                    },
                    width: 210,
                },
                {
                    title: "",
                    render: (rowData) => {
                        return (
                            <DetailButtonComponent>
                                <MenuItem onClick={() => this.detailRecord(rowData.id)}>
                                    Detail
                                </MenuItem>
                            </DetailButtonComponent>
                        );
                    },
                },
            ],
            columnsMember: [
                {
                    title: "ID Transaksi",
                    field: "transaction_number",
                    headerStyle: {
                        paddingLeft: 40,
                    },
                    cellStyle: {
                        paddingLeft: 40,
                    },
                },
                {
                    title: "Tanggal Pembayaran",
                    render: (data) => {
                        return moment(data.transaction_date).locale("id", localization).format("DD MMMM YYYY");
                    }
                },
                {
                    title: "Dana SHU",
                    render: (data) => {
                        let total;
                        if (data.amount && data.amount >= 0 && data.amount !== null) {
                            total = data.amount.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
                            return "Rp " + total;
                        } else {
                            return "-";
                        }
                    }
                },
                {
                    title: "Total Pembayaran",
                    render: (data) => {
                        let total;
                        if (data.amount_running && data.amount_running >= 0 && data.amount_running !== null) {
                            total = data.amount_running.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
                            return "Rp " + total;
                        } else {
                            return "-";
                        }
                    }
                },
            ]
        };
        this.shouldComponentRender = this.shouldComponentRender.bind(this);
        this.handleRefresh = this.handleRefresh.bind(this);
    }

    detailRecord(id) {
        this.props.history.push(`/koperasi/${id}`);
    }

    handleRefresh(state) {
        this.setState(state);
        this.tableRef.current && this.tableRef.current.onQueryChange();
    }

    shouldComponentRender() {
        const { findSHU_pending } = this.props;
        if (findSHU_pending === false) {
            return false;
        }
        return true;
    }

    render() {
        const user = getUser().role_codes[0];
        const { findSHU, findSHU_data } = this.props;
        let data = [];
        let records_total = "";
        let length = "";
        if (findSHU_data) {
            data = findSHU_data;
            records_total = data.records_total;
            length = data.data.length;
        }
        return (
            <ContentContainer>
                <HeaderSHU handleRefresh={this.handleRefresh} />
                <MaterialTable
                    tableRef={this.tableRef}
                    title="Member"
                    columns={user === "root" ? this.state.columns : this.state.columnsMember}
                    data={(query) =>
                        new Promise((resolve, reject) => {
                            let param = {
                                page: query.page + 1,
                                length: 10,
                                search_text: this.state.search,
                                id: "",
                                status: this.state.status,
                                year: this.state.year
                            };
                            findSHU(param, resolve, reject);
                        })
                    }
                    options={{
                        paginationType: "stepped",
                        pageSizeOptions: [],
                        pageSize: 10,
                        showTitle: false,
                        search: false,
                        headerStyle: {
                            backgroundColor: "#F8F9FB",
                        },
                    }}
                    components={{
                        Toolbar: () => <div />,
                        Container: (props) => <Paper {...props} elevation={0} />,
                        Pagination: (props) => (
                            <PaginationComponent
                                records={length}
                                records_total={records_total}
                                {...props}
                            />
                        ),
                    }}
                />
            </ContentContainer>
        );
    }
}

function mapStateToProps({ findSHU }) {
    return {
        findSHU_pending: getSHUKoperasiPending(findSHU),
        findSHU_data: getSHUKoperasi(findSHU),
        findSHU_error: getSHUKoperasiError(findSHU),
    };
}

export default connect(mapStateToProps, { findSHU })(withRouter(SHU));